import * as Yup from "yup";

import { variables } from "../Variables";

const { required, password_match, IsEmail } = variables;

export const newPasswordSchema = Yup.object({
  password: Yup.string().required(required),
  con_password: Yup.string()
    .required(required)
    .oneOf([Yup.ref("password"), null], password_match),
});

export const forgotPasswordSchema = Yup.object({
  email: Yup.string().required(required).email(IsEmail),
});
